import { useRecoilValue } from "recoil";
import { userPersonalInfoState } from "../store/user";
import sortAgreementCounterparties from "../utils/sort-agreement-counterparties";
import OverflowTooltipTypography from "./OverflowTooltipTypography";

interface FormattedCounterpartiesProps {
	rowData: any;
	fieldAssessor: string;
}

const FormattedCounterparties = (props: FormattedCounterpartiesProps) => {
	const { rowData, fieldAssessor } = props;

	const {
		organization: { name: organizationName },
	} = useRecoilValue(userPersonalInfoState);
	const otherCounterpartiesArr = rowData[fieldAssessor]
		.split(",")
		.map((v: string) => v.trim())
		.filter((cp: string) => !!cp && !cp.includes(organizationName));
	const otherCounterparties = otherCounterpartiesArr.join(",");
	const sortedOtherCounterparties = sortAgreementCounterparties(otherCounterparties);

	return <OverflowTooltipTypography>{sortedOtherCounterparties}</OverflowTooltipTypography>;
};

export default FormattedCounterparties;
